import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import type { BeraResultCycleSummary } from '@/types/Bera';
import { ScoreTable } from '@/components/views/BeraJob/Results/components/ScoreTable';
import { NoENSTasks } from '@/components/views/BeraJob/Results/ResultENS/NoENSTasks';

import { Accordion } from './Accordion';
import { Subtitle } from './BeraResultAccordion/styles';

const BLOCK_GUTTER = 24;

interface EnsResultAccordionProps {
	cycleSummary: BeraResultCycleSummary;
	isEns: boolean;
	jobSummaryId: string;
	open: boolean;
	onToggle: () => void;
}

export function EnsResultAccordion({
	cycleSummary,
	isEns,
	jobSummaryId,
	open,
	onToggle
}: Readonly<EnsResultAccordionProps>): JSX.Element {
	return (
		<Accordion info title={I18n.get('ENS Result')} open={open} onToggle={onToggle}>
			<Row gutter={[0, BLOCK_GUTTER]}>
				<Col span={24}>
					<Subtitle>{I18n.get('Cycle summary')}</Subtitle>
				</Col>
				<Col span={24}>
					<ScoreTable cycleSummary={cycleSummary} isENS ens={isEns} />
				</Col>
				<Col span={24}>
					<NoENSTasks bera_job_summary_id={jobSummaryId} />
				</Col>
			</Row>
		</Accordion>
	);
}
